import React, { useMemo } from 'react';
import { View } from "@/views/component/discount/style";
import Button from "@/views/component/public/button";
import { EButton, EModal } from "@/interface/enum";
import { useMobx } from "@/utils/hooks";
import { useMemoizedFn } from "ahooks";
import { Modal } from "@/views/component/modal";
import { ConfDoEntrysTasks } from "@/interface/request.interface";
import { observer } from "mobx-react-lite";

function Index() {
  const operate = useMobx('operate');

  const isJoinActive = useMemo(() => {
    let bool = false;

    if (!bool) {
      operate.dayFreeTask.forEach((gameTask: ConfDoEntrysTasks) => {
        if (gameTask.taskStatus === 100) {
          bool = true;
        }
      })
    }

    return bool
  }, [operate.dayFreeTask])

  const isJoinRecharge = useMemo(() => {
    let bool = false;

    if (!bool) {
      operate.dayRechargeTask.forEach((rechargeTask: ConfDoEntrysTasks) => {
        if (rechargeTask.taskStatus === 100) {
          bool = true;
        }
      })
    }

    return bool
  }, [operate.dayRechargeTask])

  const handleOriginalBuy = useMemoizedFn(() => {
    if (isJoinActive || isJoinRecharge) {
      window.open(CONFIG.discount.linkSite.originalBuy, '_blank');
      return
    }
    $refPopup.current.open(<Modal modalType={EModal['提示']} message={CONFIG.discount.modalTip.originalBuy}/>);
  });
  const handleDiscountBuy = useMemoizedFn(() => {
    if (isJoinActive || isJoinRecharge) {
      window.open(CONFIG.discount.linkSite.discountBuy, '_blank');
      return
    }
    $refPopup.current.open(<Modal
      modalType={EModal['提示']}
      message={CONFIG.discount.modalTip.discountBuy}
      confirmFn={(props: any) => {
        window.scrollTo(0, 300);
        props.clearAll()
      }}
    />);
  });

  const handleGetLog = useMemoizedFn(() => {
    const params = {
      type: 0,
      params: [
        `//hd.vip.yy.com/vip/activity/prize/${CONFIG.discount.YYVIPACTCODE}/${CONFIG.discount.YYVIPDRAWGIFTGROUPID}/list`,
        {
          // dataType: 'jsonp',
          data: {
            actId: CONFIG.discount.YYVIPACTCODE,
            groupId: CONFIG.discount.YYVIPDRAWGIFTGROUPID,
            type:1,
            pageNo: 1,
            pageSize: 999
          },
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
        },
         true
      ],

    };
    $refPopup.current.open(<Modal
      modalType={EModal['领取记录']}
      other={params}
    />);
  })
  const handlePresenterLog = useMemoizedFn(() => {
    const postData = {
      type: 1,
      params: [
        `//hd.vip.yy.com/vip/activity/prize/${CONFIG.discount.YYVIPACTCODE}/${CONFIG.discount.YYVIPDRAWGIFTGROUPID}/list`,
        {
          // dataType: 'jsonp',
          data: {
            actId: CONFIG.discount.YYVIPACTCODE,
            groupId: CONFIG.discount.YYVIPDRAWGIFTGROUPID,
            type:2,
            pageNo: 1,
            pageSize: 999
          },
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
        },
        true
      ],
    };
    $refPopup.current.open(<Modal
      modalType={EModal['赠送记录']}
      other={postData}
    />);
  })

  return <View>
    <div className="tip1" dangerouslySetInnerHTML={({ __html: CONFIG.discount.tip1 })}></div>
    <div className="tip2" dangerouslySetInnerHTML={({ __html: CONFIG.discount.tip2 })}></div>
    <div className="tip3" dangerouslySetInnerHTML={({ __html: CONFIG.discount.tip3 })}></div>
    {/*领取记录*/}
    <div onClick={() => handleGetLog()} className="log"/>
    {/*赠送记录*/}
    <div onClick={() => handlePresenterLog()} className="presenter"/>
    <ul>
      {CONFIG.discount.award.map((item: any, index: number) => {
        return <li key={index}>
          <img src={item.awardImg} alt=""/>
          <p>{item.name}</p>
        </li>
      })}
    </ul>
    <Button onClick={() => handleDiscountBuy()} type={EButton["折扣-折扣购买"]} className="discount"/>
    <Button onClick={() => handleOriginalBuy()} type={EButton["折扣-原价购买"]} className="origin"/>
  </View>
}

export default observer(Index);
